import { decisionItem } from './decisionItem';
export var decisionList = function decisionList(node) {
  var result = [];
  node.forEach(function (item) {
    result.push(decisionItem(item));
  });
  return result.join('\n');
};